// @unocss-include
'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import classNames from 'clsx';
import { BoxContext } from '../box/Box.js';
function Content(_a) {
    var { children, className, color = 'contrast' } = _a, props = __rest(_a, ["children", "className", "color"]);
    return (_jsx(TooltipPrimitive.Portal, { children: _jsx(BoxContext.Provider, { value: { spacingScale: 1 }, children: _jsxs(TooltipPrimitive.Content, Object.assign({ className: classNames('layer-components:relative layer-components:rounded-sm layer-components:py-2 layer-components:px-3 layer-components:text-sm layer-components:leading-tight layer-components:shadow-sm layer-components:select-none layer-components:hidden layer-components:z-tooltip', '[&[data-state=delayed-open]]:flex', '[&[data-state=instant-open]]:flex', 'layer-components:transform-origin-[var(--radix-tooltip-content-transform-origin)]', 'layer-components:[&[data-state=delayed-open]]:animate-popover-in', {
                    'layer-variants:bg-black layer-variants:color-white': color === 'contrast',
                    'layer-variants:bg-white layer-variants:color-black': color === 'white' || color === 'neutral',
                    'layer-variants:bg-attention-ink layer-variants:color-white': color === 'attention',
                }, className) }, props, { children: [children, _jsx(TooltipPrimitive.Arrow, { className: "layer-components:arrow" })] })) }) }));
}
export const TooltipProvider = TooltipPrimitive.Provider;
export const Tooltip = Object.assign(function Tooltip(_a) {
    var { ref, content, children, open, disabled, className, sideOffset = 12, side, color } = _a, rest = __rest(_a, ["ref", "content", "children", "open", "disabled", "className", "sideOffset", "side", "color"]);
    return (_jsxs(TooltipPrimitive.Root, { open: open, children: [disabled ? (children) : (_jsx(TooltipPrimitive.TooltipTrigger, Object.assign({ asChild: true, ref: ref }, rest, { children: children }))), _jsx(Content, { color: color, side: side, sideOffset: sideOffset, className: className, children: content })] }));
}, {
    Trigger: TooltipPrimitive.TooltipTrigger,
    Content,
});
//# sourceMappingURL=Tooltip.js.map